import { IProductSelosProps, cards as items } from 'utils/cards';

import CardItem from './CardItem';

import * as S from './styles';

interface CardsListProps {
  hovered: boolean;
  productSelos: IProductSelosProps;
  animationSelo?: 'yes' | 'only-icon' | 'only-expanded';
}

export default function CardsList({
  hovered,
  productSelos,
  animationSelo = 'yes',
}: CardsListProps) {
  const filteredItems = items.filter(item => {
    // Se o item existir em productSelos e for true, mantém no array filtrado
    if (productSelos[item.id] === true) {
      return true;
    }

    // Se o item for do tipo 'importado', verifica se a string bate com o id
    if (item.id.startsWith('importado') && item.id === productSelos.importado) {
      return true;
    }

    return false;
  });

  return (
    <S.Container className="icons-list">
      {filteredItems
        .map((item, index) => (
          <CardItem
            key={index}
            item={item}
            index={index}
            length={items.length}
            hovered={true}
            animationSelo={
              item.name === 'UltraPremio' ? 'only-icon' : animationSelo
            }
          />
        ))
        .slice(0, 6)}
    </S.Container>
  );
}
